import { Clipboard } from '@angular/cdk/clipboard';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ServiceCategory } from 'src/app/db/models/categories';
import { Address, ContactNos, ProService } from 'src/app/db/models/pro-services';
import { ServiceHandle } from 'src/app/db/models/service-handle';
import { User } from 'src/app/db/models/user';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { ProfessionalServiceService } from 'src/app/services/professional-service.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-professional-services-detail',
  templateUrl: './professional-services-detail.component.html',
  styleUrls: ['./professional-services-detail.component.scss']
})
export class ProfessionalServicesDetailComponent implements OnInit {

  title = 'Service Detail';

  pservice: ProService;
  addresses: Address[];
  contacts: ContactNos[];
  user: User;
  category: ServiceCategory;
  handles: ServiceHandle[];

  is_default_user = true;

  constructor(private route: ActivatedRoute,
              private _service: ProfessionalServiceService,
              private authenticate: AuthenticationService,
              private service: UserService,
              private clipboard: Clipboard,
              private notify: ToastrService)
          {
            this.authenticate.currentUser.subscribe(x => this.user = x);

          }

  ngOnInit() {
    const stateParams = this.route.snapshot.paramMap.get('id');
    if(stateParams != null){
      const id = stateParams;
      this.getServiceDetail(id);
      if(this.user.serviceId == id){
        this.is_default_user = false;
        this.getUserDetails(this.user.id);
      }
    }
  }


  getServiceDetail(id: string) {
    this._service.getserviceDetail(id).subscribe({
      next: res => {
        this.pservice = res;
        this.handles = res.serviceHandles;
      },
      error: err => {
        console.error(err);
      }
    })
  }

  copyContact(): void {
    const successful = this.clipboard.copy(this.pservice.primaryContactNumber);
    if (successful) {
      this.notify.info('Contact Copied');
    } else {
      this.notify.warning('Copy failed');
    }
  }

  getUserDetails(id: string){
    this.service.getUserDetails(id).subscribe({
      next: res => {
        this.user = res;
        // this.pservice = res.service;
        this.category = res.category;
        console.log(this.user)
      },
      error: err => {
        console.error(err);
      }
    })
  }

}
